import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "expo-router";
import { useForm } from "react-hook-form";
import { ActivityIndicator, Alert, Text, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import * as z from "zod";
import { Button, Form, FormField, FormInput } from "@/components/ui";
import * as Linking from 'expo-linking';
import { trpc } from "@/trpc/react";
import { KeyboardAwareScrollView, KeyboardToolbar } from "react-native-keyboard-controller";

const formSchema = z.object({
  email: z.string().email("Please enter a valid email address."),
});

export default function ResetPassword() {
  const router = useRouter();
  const insets = useSafeAreaInsets();

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: "",
    },
  });

  const { mutate: resetPassword, isPending } = trpc.auth.resetPassword.useMutation({
    onSuccess() {
      promptResetPasswordSuccess();
      form.reset();
    },
    onError(error) {
      console.error(error);
      Alert.alert("An error occurred. Please try again.");
    }
  });

  async function onSubmit(data: z.infer<typeof formSchema>) {
    try {
      const resetPasswordURL = Linking.createURL("reset-password");
      resetPassword({ email: data.email, redirect_url: resetPasswordURL });
    } catch (error: Error | any) {
      Alert.alert(error.message)
    }
  }

  function promptResetPasswordSuccess() {
    Alert.alert(
      'Password reset sent!',
      'Please check your emails for a password reset link.',
      [
        { text: 'Ok', style: 'cancel' },

      ],
      { cancelable: false }
    );
  }

  return (
    <>
      <KeyboardAwareScrollView
        bottomOffset={62}
        className="flex-1 bg-background p-4"
        contentContainerStyle={{
          gap: 20,
          paddingTop: 40,
          paddingBottom: 20 + insets.bottom,
        }}
      >
        <View className="flex-1">
          <Text className="text-4xl text-foreground font-extrabold tracking-tight lg:text-5xl self-start mb-5">
            Reset your password
          </Text>
          <Form {...form}>
            <View className="gap-4">
              <FormField
                control={form.control}
                name="email"
                render={({ field }) => (
                  <FormInput
                    label="Email"
                    placeholder="Email"
                    autoCapitalize="none"
                    autoComplete="email"
                    autoCorrect={false}
                    keyboardType="email-address"
                    {...field}
                  />
                )}
              />
            </View>
          </Form>
        </View>
        <View className="gap-y-4 android:pb-4">
          <Button
            size="default"

            variant="crew"
            onPress={form.handleSubmit(onSubmit)}
          >
            {form.formState.isSubmitting || isPending ? (
              <ActivityIndicator size="small" />
            ) : (
              "Reset password"
            )}
          </Button>
          <Text
            className="text-sm text-muted-foreground text-center"
            onPress={() => {
              router.replace("/sign-in");
            }}
          >
            Have an account?{" "}
            <Text className="leading-7 text-foreground">Sign in</Text>
          </Text>
        </View>
      </KeyboardAwareScrollView>
      <KeyboardToolbar />
    </>
  );
}